const FILEROUTES = {
    UPLOAD: "files/upload/",
  };
  export default FILEROUTES;